module.exports = __webpack_public_path__ + "static/media/pre3.52aa56a8.jpg";